<script setup>
import debounce from 'lodash.debounce';
import { useRouter } from 'vue-router';
import { useTemplateRef } from 'vue';
import { useLocationsStore } from '@@/stores/Locations';

const props = defineProps({
  location: {
    type: Object,
    required: true,
  },
});

const container = useTemplateRef('container');
const locationsStore = useLocationsStore();
const router = useRouter();

const forecastCurrent = computed(() => props.location.forecast_current);
const forecastDaily = computed(() => props.location.forecast_daily);

const handleContainerScroll = debounce(function handleContainerScroll() {
  const scrollLeft = container.value?.scrollLeft;

  if (typeof scrollLeft === 'number') {
    locationsStore.setScrollLeft(scrollLeft);
  }
}, 10);

const handleClickForecastDay = (forecastDay) => {
  const url = `/location/${props.location.slug}/weather#day${forecastDay + 1}`;
  router.push(url);
};

watch(() => locationsStore.ui.scrollLeft, () => {
  container.value.scrollLeft = locationsStore.ui.scrollLeft;
});
</script>

<template>
  <Card>
    <template #body>
      <SnowLocationHeader
        class="tw-p-2.5"
        :location="location"
      />
      <CurrentConditions
        class="tw--mt-2 tw-p-2.5 lg:tw-p-3.5 border-color tw-border-b"
        :forecast-current="forecastCurrent"
      />
      <div
        ref="container"
        :class="[
          'tw-overflow-x-auto lg:tw-overflow-hidden hide-scrollbar-on-mobile',
          'tw-overflow-y-hidden',
        ]"
        @scroll="handleContainerScroll"
      >
        <ForecastTable
          :can-select-forecast-day="true"
          :forecast-daily="forecastDaily"
          @click-forecast-day="handleClickForecastDay"
        />
      </div>
    </template>
  </Card>
</template>
